module.exports = __webpack_public_path__ + "static/media/voicememo.4f8bbb43.m4a";